import { useEffect, useState } from "react";
import { emailTemplateService } from "../api/emailTemplate.service";

export function useEmailTemplates() {

  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  async function fetchTemplates() {
    setLoading(true);
    try {
      const res = await emailTemplateService.list();
      setTemplates(res.data);
    } finally {
      setLoading(false);
    }
  }

  async function createTemplate(data) {
    const res = await emailTemplateService.create(data);
    setTemplates(prev => [res.data, ...prev]);
  }

  async function updateTemplate(id, data) {
    const res = await emailTemplateService.update(id, data);
    setTemplates(prev =>
      prev.map(t => (t.id === id ? res.data : t))
    );
  }

  async function toggleStatus(id, isActive) {
    await emailTemplateService.updateStatus(id, isActive);
    setTemplates(prev =>
      prev.map(t => (t.id === id ? { ...t, isActive } : t))
    );
  }

  useEffect(() => {
    fetchTemplates();
  }, []);

  return {
    templates,
    loading,
    createTemplate,
    updateTemplate,
    toggleStatus,
    refresh: fetchTemplates
  };
}